import { z } from "zod";

export const HouseholdRoleSchema = z.enum(["owner", "member", "child"]);
export type HouseholdRole = z.infer<typeof HouseholdRoleSchema>;

export const HouseholdSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1).max(80),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
});
export type Household = z.infer<typeof HouseholdSchema>;

export const HouseholdCreateSchema = z.object({
  name: z.string().trim().min(1, "Nazwa nie może być pusta").max(80),
});
export type HouseholdCreate = z.infer<typeof HouseholdCreateSchema>;

export const HouseholdMemberSchema = z.object({
  userId: z.string(),
  email: z.string().email(),
  name: z.string().nullable(),
  role: HouseholdRoleSchema,
  joinedAt: z.number().int(),
});
export type HouseholdMember = z.infer<typeof HouseholdMemberSchema>;

export const HouseholdInviteSchema = z.object({
  id: z.string(),
  code: z.string(),
  householdId: z.string(),
  createdAt: z.number().int(),
  expiresAt: z.number().int(),
  acceptedAt: z.number().int().nullable(),
});
export type HouseholdInvite = z.infer<typeof HouseholdInviteSchema>;
